import { BaseReportTrigger, Report } from '@/feature/reports/types/Report'

import { useNetworkMutation } from '@/lib/utils/request'

export type TaskReportTrigger = BaseReportTrigger & {
  orgTo?: number
  orgFrom?: number
  status?: string[]
}

export const useExportTasksRequest = () =>
  useNetworkMutation<Report, TaskReportTrigger>({
    url: `/v1/reports/task/`,
    method: 'post',
  })
